import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextMedium, TextRegular, TextSemiBold } from 'UiKit/typography';
import formatPromoPeriod from 'View/host-stock-promo/helper/formatPromoPeriod';
import StatusBadge from 'View/host-stock-promo/component/status-badge';
import StoreBadge from 'View/host-stock-promo/component/store-badge';

import styles from './styles.module.css';

const InfoPromoDetail = ({ data }) => {
  const { t } = useTranslation('host-stock-promo');
  const promoPeriodValue = formatPromoPeriod(data?.promoPeriod);
  const [startDate, endDate] = promoPeriodValue?.split(' - ') || ['', ''];
  return (
    <Box className={styles['info-promo-detail__container']} data-testid="info-promo-detail">
      <Box className={styles['top__section']}>
        <TextSemiBold className={styles['promo-name__text']} color="#1A1A1A">
          {data?.name}
        </TextSemiBold>
        <StatusBadge name={data?.status} />
      </Box>
      <Box className={styles['bottom__section']}>
        <Box className={styles['period__container']}>
          <TextRegular className={styles['label__text']}>{t('promo_detail.period')}</TextRegular>
          <TextMedium className={styles['period-value__text']}>
            {startDate} -<br /> {endDate}
          </TextMedium>
        </Box>
        <Box className={styles['store__container']}>
          <TextRegular className={styles['label__text']}>{t('promo_detail.account')}</TextRegular>
          <StoreBadge store={{ name: data?.storeName, ecommerce: data?.ecommerce }} />
        </Box>
      </Box>
    </Box>
  );
};

export default InfoPromoDetail;
